export default __webpack_public_path__ + "static/media/gpsWireless_feature3.a7ddd8e4.svg";